<ng-container *ngIf="!isInsideModal">
	<div class="container-fluid basic_table">
		<div class="row">
			<div class="col-sm-12">
				<div class="card">
					<div class="card-header d-flex justify-content-between">
						<h5 style="color: grey;">{{ translate.instant('customers.title') }}</h5>
						<div>
							<button
								[hidden]="user_type == 200"
								class="btn m-1"
								style="background-color: #141414; color: #fff;"
								(click)="openXl()">
								<i class="fa fa-plus-circle mx-1"></i>
								{{ translate.instant('customers.actions.addCustomer') }}
							</button>
							<button
								class="btn m-1 mx-1 btn-outline-warning"
								(click)="getAllCustomersBasedOnMerchant()">
								<i class="fa fa-refresh mx-1"></i>
								{{ translate.instant('customers.actions.refresh') }}
							</button>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-5">
							<div class="form-group search m-3">
								<label for="seaarch" class="ml-2" style="color: grey;">{{ translate.instant('customers.search.label') }}</label>
								<input
									class="form-control w-100"
									type="text"
									name="search"
									[ngModelOptions]="{standalone: true}"
									id="seaarch"
									[(ngModel)]="term"
									(input)="filterCustomers()"
									placeholder="{{ translate.instant('customers.search.placeholder') }}"/>
							</div>
						</div>
					</div>
					<div class="card-block row">
						<div class="col-sm-12 col-lg-12 col-xl-12">
							<!-- Desktop table (lg+) -->
							<div class="table-responsive d-none d-lg-block">
								<table class="table table-light text-center table-hover">
									<thead>
										<tr>
											<th scope="col">{{ translate.instant('customers.table.headers.index') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerName') }}</th>
											<th scope="col">{{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerPhone') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerVatNumber') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerVatTax') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.idNumber') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerType') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.status') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.createdDate') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.accountCard') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.view') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.update') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.delete') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of customersData; let i = index">
											<td scope="row">{{ getCustomerRowNumber(i) }}</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(customerDisplayNameShort(item))">{{ customerDisplayNameShort(item) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(companyDisplayName(item))">{{ companyDisplayName(item) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.formattedPhone ?? item.customer_phone))">{{ displayOptional(item.formattedPhone ?? item.customer_phone) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.customer_vat_number))">{{ displayOptional(item.customer_vat_number) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.customer_vat_tax))">{{ displayOptional(item.customer_vat_tax) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.id_number))">{{ displayOptional(item.id_number) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isUnknownCustomerType(item)">{{ customerTypeLabel(item) }}</span>
											</td>
											<td>
												<button
													*ngIf="item.customer_status==1"
													class="btn"
													style="border: none;"
													(click)="changeStatus(item?.customer_id, item.customer_status)">
													<i class="fa solid fa-solid fa-toggle-on " style=" color: #213FA6;" ></i>
												</button>
												<button
													*ngIf="item.customer_status==59"
													class="btn"
													style="border: none;"
													(click)="changeStatus(item?.customer_id, item.customer_status)">
													<i class="fa solid fa-solid fa-toggle-off " style=" color: red;"></i>
												</button>
												<span *ngIf="item.customer_status != 1 && item.customer_status != 59" class="customers-table__empty-cell">{{ emptyCellDisplay }}</span>
											</td>
											<td>
												<span *ngIf="item.createdDate">{{ item.createdDate | date: 'dd/MM/yyyy' }}</span>
												<span *ngIf="!item.createdDate" class="customers-table__empty-cell">{{ emptyCellDisplay }}</span>
											</td>
											<td>
												<button
													type="button"
													class="btn customers-account-card-btn"
													(click)="openAccountCard(item)"
													[title]="translate.instant('customers.actions.accountCard')"
													[attr.aria-label]="translate.instant('customers.actions.accountCard')">
													<i class="fa fa-file-text-o" aria-hidden="true"></i>
												</button>
												<button
													type="button"
													class="btn customers-account-card-btn"
													(click)="openFeeAgreements(item)"
													[title]="translate.instant('customers.actions.feeAgreements')"
													[attr.aria-label]="translate.instant('customers.actions.feeAgreements')">
													<i class="fa fa-handshake-o" aria-hidden="true"></i>
												</button>
											</td>
											<td>
												<button
													class="btn"
													style="border: none;"
													(click)="executeFunctionsView( item?.customer_id,viewData )">
													<i class="fa fa-eye" style="color: grey; cursor: pointer;"></i>
												</button>
											</td>
											<td>
												<button
													class="btn"
												style="border: none;"
													(click)="executeFunctions( item?.customer_id, item )">
													<i class="fa fa-edit" style=" cursor: pointer; color: green;"></i>
												</button>
											</td>
											<td>
												<button
													[ngStyle]="{ 'pointer-events': item.customer_status == 1 ? 'none' : 'auto', 'color': item.customer_status == 1 ? 'gray' : 'red' }"
													class="btn"
													style="border: none;"
													(click)="getId(item?.customer_id);openVerticallyCentered(dataDeleted)">
													<i class="fa fa-trash-o" style=" cursor: pointer;"></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- Mobile & tablet cards (< lg) -->
							<div class="crud-cards-list d-lg-none">
								<div class="crud-card" *ngFor="let item of customersData; let i = index">
									<div class="cc-header">
										<div class="cc-avatar">
											<span>{{ (curentLang === 'en' ? item.customer_name_en : (curentLang === 'ar' ? item.customer_name_ar : item.customer_name_he))?.charAt(0)?.toUpperCase() || '?' }}</span>
										</div>
										<div class="cc-title-block">
											<div class="cc-name">{{ customerDisplayName(item) }}</div>
											<div class="cc-sub" [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.formattedPhone ?? item.customer_phone))">{{ displayOptional(item.formattedPhone ?? item.customer_phone) }}</div>
										</div>
										<span class="cc-badge" [style.background]="item.customer_status == 1 ? '#e8f5e9' : '#f5f5f5'" [style.color]="item.customer_status == 1 ? '#2e7d32' : '#757575'">
											{{ item.customer_status == 1 ? (curentLang === 'ar' ? 'نشط' : (curentLang === 'he' ? 'פעיל' : 'Active')) : (curentLang === 'ar' ? 'غير نشط' : (curentLang === 'he' ? 'לא פעיל' : 'Inactive')) }}
										</span>
									</div>
									<div class="cc-body">
										<div class="cc-info-row">
											<span class="cc-label">{{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}</span>
											<span class="cc-value" [class.customers-table__empty-cell]="isEmptyCellText(companyDisplayName(item))">{{ companyDisplayName(item) }}</span>
										</div>
										<div class="cc-info-row">
											<span class="cc-label">{{ translate.instant('customers.table.headers.customerType') }}</span>
											<span class="cc-value" [class.customers-table__empty-cell]="isUnknownCustomerType(item)">{{ customerTypeLabel(item) }}</span>
										</div>
										<div class="cc-info-row">
											<span class="cc-label">{{ translate.instant('customers.table.headers.createdDate') }}</span>
											<span class="cc-value" *ngIf="item.createdDate">{{ item.createdDate | date: 'dd/MM/yyyy' }}</span>
											<span class="cc-value customers-table__empty-cell" *ngIf="!item.createdDate">{{ emptyCellDisplay }}</span>
										</div>
										<div class="cc-info-row">
											<span class="cc-label">{{ translate.instant('customers.table.headers.status') }}</span>
											<button *ngIf="item.customer_status==1" class="btn p-0 border-0" (click)="changeStatus(item?.customer_id, item.customer_status)">
												<i class="fa fa-toggle-on" style="color: #213FA6; font-size: 20px;"></i>
											</button>
											<button *ngIf="item.customer_status==59" class="btn p-0 border-0" (click)="changeStatus(item?.customer_id, item.customer_status)">
												<i class="fa fa-toggle-off" style="color: red; font-size: 20px;"></i>
											</button>
										</div>
									</div>
									<div class="cc-actions">
										<button type="button" class="cc-action-btn cc-action-ledger" (click)="openAccountCard(item)" [title]="translate.instant('customers.actions.accountCard')">
											<i class="fa fa-file-text-o"></i>
										</button>
										<button type="button" class="cc-action-btn cc-action-ledger" (click)="openFeeAgreements(item)" [title]="translate.instant('customers.actions.feeAgreements')">
											<i class="fa fa-handshake-o"></i>
										</button>
										<button class="cc-action-btn cc-action-view" (click)="executeFunctionsView(item?.customer_id, viewData)" [title]="translate.instant('customers.table.headers.view')">
											<i class="fa fa-eye"></i>
										</button>
										<button class="cc-action-btn cc-action-edit" (click)="executeFunctions(item?.customer_id, item)" [title]="translate.instant('customers.table.headers.update')">
											<i class="fa fa-edit"></i>
										</button>
										<button [attr.disabled]="item.customer_status == 1 ? true : null" class="cc-action-btn cc-action-delete" (click)="getId(item?.customer_id);openVerticallyCentered(dataDeleted)" [title]="translate.instant('customers.table.headers.delete')">
											<i class="fa fa-trash-o"></i>
										</button>
									</div>
								</div>
							</div>

							<div class="pagination-container d-lg-none">
								<span class="customers-page-report">{{ pageReport }}</span>
								<pagination-controls
									id="customers-mobile"
									[previousLabel]="paginationPreviousLabel"
									[nextLabel]="paginationNextLabel"
									(pageChange)="onPageChange($event)">
								</pagination-controls>
							</div>

						<div class="pagination-container d-none d-lg-flex">
							<span class="customers-page-report">{{ pageReport }}</span>
							<pagination-controls
								id="customers-desktop"
								[previousLabel]="paginationPreviousLabel"
								[nextLabel]="paginationNextLabel"
								(pageChange)="onPageChange($event)">
							</pagination-controls>
						</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>


<app-add-customer-modal [showModal]="showAddCustomerModal" [mode]="customerModalMode"
	[customerData]="selectedCustomerData" (onClose)="onCustomerModalClose()" (onSave)="onCustomerModalSave($event)">
</app-add-customer-modal>

<ng-template #updatedData let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title"style="color: grey;">
			{{ translate.instant('customers.modal.updateTitle') }}
		</h6>
		<button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid ">
			<div class="edit-profile">
				<div class="row d-flex justify-content-between">
					<form  [formGroup]="updateCustomer"  novalidate [ngClass]="{ 'was-validated': updatevalidate }">
						<div class="row">
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerNameAr') }}
								</label>
								<input style="color: grey;"
									class="form-control" maxlength="80"
									type="text" formControlName="customer_name_ar" />
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerNameEn') }}
								</label>
								<input style="color: grey;"
									class="form-control"
									type="text"
									maxlength="80"
									formControlName="customer_name_en" />
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerNameHe') }}
									<span class="text-danger" style="color: red;">*</span>
								</label>
								<input style="color: grey;" class="form-control"
									type="text"
									formControlName="customer_name_he"
									maxlength="80"
									required="" onlyAlphabets />
								<div class="invalid-feedback text-danger">{{ translate.instant('customers.modal.form.customerNameRequired') }}</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerType') }}
									<span class="text-danger" style="color: red;">*</span>
								</label>
								<div *ngIf="updateCustomer.get('customer_type')?.value === 5">
									<input class="form-control" readonly
										value="{{ translate.instant('customers.table.customerTypes.individual') }}">
								</div>
								<div *ngIf="updateCustomer.get('customer_type')?.value === 6">
									<input class="form-control" readonly
										value="{{ translate.instant('customers.table.customerTypes.company') }}">
								</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerPhone') }}
								</label>
								<div class="input-group">
									<span style="color: #141414;" class="input-group-text">+972</span>
									<input class="form-control" type="text" maxlength="10"    formControlName="customer_phone">
								</div>
								<div *ngIf="updateCustomer.get('customer_phone')?.errors != null && updateCustomer.get('customer_phone')?.touched" class="alert text-danger my-1">
									<p *ngIf="updateCustomer.get('customer_phone')?.errors?.required" class="my-1 text-danger">{{'Register.phoneRequierd'|translate}}</p>
									<p *ngIf="updateCustomer.get('customer_phone')?.errors?.invalidMobilePrefix" class="my-1 text-danger">{{updateCustomer.get('customer_phone')?.errors?.invalidMobilePrefix.message}}</p>
									<p *ngIf="updateCustomer.get('customer_phone')?.errors?.invalidPhoneNumber" class="my-1 text-danger">{{updateCustomer.get('customer_phone')?.errors?.invalidPhoneNumber.message}}</p>
								</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 " *ngIf="updateCustomer?.value?.customer_type != 6">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.idNumber') }}
								</label>
								<input style="color: grey;"
									class="form-control" type="number"
									formControlName="id_number"
									maxlength="20" />
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.cityNameHe') }}
								</label>
								<input style="color: grey;"
									class="form-control" type="text"
									formControlName="customer_address_city"
									maxlength="20" />
								<div class="invalid-feedback text-danger">{{ translate.instant('customers.modal.form.validation.customerAddressCity') }}
								</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.streetNameHe') }}
								</label>
								<input style="color: grey;"
									class="form-control" type="text"
									formControlName="customer_address_str"
									maxlength="20" />
								<div class="invalid-feedback text-danger">{{ translate.instant('customers.modal.form.validation.customerAddressStreet')
									}}</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.buildingNumber') }}
								</label>
								<input style="color: grey;"
									class="form-control" type="number"
									formControlName="customer_Building_number"
									maxlength="20" />
								<div class="invalid-feedback text-danger">{{ translate.instant('customers.modal.form.validation.customerBuildingNumber')
									}}</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 ">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.zipCode') }}
								</label>
								<input style="color: grey;"
									class="form-control" type="number"
									formControlName="customer_address_zip_code"
									maxlength="20" />
								<div class="invalid-feedback text-danger">{{ translate.instant('customers.modal.form.validation.customerZipCode') }}
								</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 " *ngIf="updateCustomer.value.customer_type != 5">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerVatNumber') }}
									<span class="text-danger" style="color: red;">*</span>
								</label>
								<input style="color: grey;"
									class="form-control"
									type="text"
									(keypress)="isNumber($event)"
									maxlength="9"
									max="9"
									min="0"
									required="" onlyAlphabets
									inputmode="numeric"
									pattern="[0-9]{9}"
									title="{{ translate.instant('customers.modal.form.validation.vatNumberDigits') }}"
									formControlName="customer_vat_number"
									[ngClass]="{ 'is-invalid': validate && updateCustomer.controls['customer_vat_number'].invalid }" />
								<div *ngIf="validate && updateCustomer.controls['customer_vat_number'].invalid" class="invalid-feedback text-danger">
									{{ translate.instant('customers.modal.form.validation.vatNumberDigits') }}
									<span class="text-danger" style="color: red;">*</span>
								</div>
							</div>
							<div class="mb-3 col-xl-4 col-md-4 " *ngIf="updateCustomer.value.customer_type != 5">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.customerVatTax') }}
								</label>
								<input style="color: grey;"
									class="form-control"
									type="number"
									formControlName="customer_vat_tax"
									maxlength="20" />
							</div>
						</div>
						<hr>
						<h6 class="modal-title" style="color: grey;">
							{{ curentLang === 'en' ? 'Additional fields' : (curentLang === 'ar' ? ' حقول اضافية   ' : 'שדות נוספים')}}
						</h6>
						<hr style="width: 25%;">
						<div class="row">
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.cityNameAr') }}
								</label>
								<input
									style="color: grey;"
									class="form-control"
									type="text"
									formControlName="customer_address_city_ar"
									maxlength="20" />
							</div>
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.cityNameEn') }}
								</label>
								<input
									style="color: grey;"
									class="form-control"
									type="text"
									formControlName="customer_address_city_en"
									maxlength="20" />
							</div>
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.streetNameAr') }}
								</label>
								<input
									style="color: grey;"
									class="form-control"
									type="text"
									formControlName="customer_address_str_ar"
									maxlength="20" />
							</div>
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="form-label" style="color: grey;">
									{{ translate.instant('customers.modal.form.streetNameEn') }}
								</label>
								<input
									style="color: grey;"
									class="form-control"
									type="text"
									formControlName="customer_address_str_en"
									maxlength="20" />
							</div>
						</div>
						<div class="modal-footer">
							<button type="button"
								class="btn btn-sm m-auto mt-2"
								style="background-color: #141414; color: #fff;"
								(click)="updatedCustomerData()">
								{{ translate.instant('customers.modal.confirm') }}
								<i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
							</button>
							<button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
								{{ translate.instant('customers.modal.back') }}
								<i class="fa fa-rotate-left mx-1"></i>
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #viewData let-modal>
	<div class="customer-view" *ngIf="viewedCustomer as customer">
	<div class="modal-header customer-view__header">
		<div class="customer-view__who">
			<div class="customer-view__avatar" aria-hidden="true">{{ viewInitial(customer) }}</div>
			<div class="customer-view__who-text">
				<p class="customer-view__kicker">{{ translate.instant('customers.modal.viewTitle') }}</p>
				<h2 class="customer-view__name" [class.is-empty]="isEmptyCellText(customerDisplayName(customer))">{{ customerDisplayName(customer) }}</h2>
				<div class="customer-view__chips">
					<span class="customer-view__chip" [class.is-company]="isCompanyCustomer(customer)" [class.is-empty]="isUnknownCustomerType(customer)">{{ customerTypeLabel(customer) }}</span>
					<span class="customer-view__chip is-quiet" [class.is-empty]="isEmptyCellText(companyDisplayName(customer))">{{ companyDisplayName(customer) }}</span>
				</div>
			</div>
		</div>
		<button type="button" class="customer-view__close" [attr.aria-label]="translate.instant('customers.modal.viewClose')" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body customer-view__body">
		<p class="customer-view__lead">{{ translate.instant('customers.modal.viewLead') }}</p>
		<section class="customer-view-section">
			<header class="customer-view-section__head">
				<span class="customer-view-section__icon" aria-hidden="true"><i class="fa fa-user"></i></span>
				<h3 class="customer-view-section__title">{{ translate.instant('shared.addCustomerModal.sections.identity') }}</h3>
			</header>
			<div class="row g-3">
				<div class="col-12 col-md-6 col-xl-4">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.customerNameHe') }}</div>
						<div class="customer-view-field__value" [class.is-empty]="isEmptyCellText(customerDisplayName(customer))">{{ customerDisplayName(customer) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-4">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.customerType') }}</div>
						<div class="customer-view-field__value" [class.is-empty]="isUnknownCustomerType(customer)">{{ customerTypeLabel(customer) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-4">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.company') }}</div>
						<div class="customer-view-field__value" [class.is-empty]="isEmptyCellText(companyDisplayName(customer))">{{ companyDisplayName(customer) }}</div>
					</div>
				</div>
			</div>
		</section>

		<section class="customer-view-section">
			<header class="customer-view-section__head">
				<span class="customer-view-section__icon" aria-hidden="true"><i class="fa fa-phone"></i></span>
				<h3 class="customer-view-section__title">{{ translate.instant('shared.addCustomerModal.sections.contact') }}</h3>
			</header>
			<div class="row g-3">
				<div class="col-12 col-md-6">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.phoneNumber') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(viewPhone(customer))">{{ viewPhone(customer) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.email') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_email))">{{ displayOptional(customer.customer_email) }}</div>
					</div>
				</div>
				<div class="col-12">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.showContactOnDocuments') }}</div>
						<div class="customer-view-field__value">
							<span class="customer-view__badge" [class.is-on]="isAffirmative(customer.show_contact_on_documents) === true" [class.is-off]="isAffirmative(customer.show_contact_on_documents) === false" [class.is-empty]="isAffirmative(customer.show_contact_on_documents) === null">{{ viewYesNo(customer.show_contact_on_documents) }}</span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="customer-view-section">
			<header class="customer-view-section__head">
				<span class="customer-view-section__icon" aria-hidden="true"><i class="fa fa-map-marker"></i></span>
				<h3 class="customer-view-section__title">{{ translate.instant('shared.addCustomerModal.sections.address') }}</h3>
			</header>
			<div class="row g-3">
				<div class="col-12 col-md-6 col-xl-3">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.city') }}</div>
						<div class="customer-view-field__value" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_address_city))">{{ displayOptional(customer.customer_address_city) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-3">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.street') }}</div>
						<div class="customer-view-field__value" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_address_str))">{{ displayOptional(customer.customer_address_str) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-3">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.buildingNumber') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_Building_number))">{{ displayOptional(customer.customer_Building_number) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-3">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.zipCode') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_address_zip_code))">{{ displayOptional(customer.customer_address_zip_code) }}</div>
					</div>
				</div>
			</div>
		</section>

		<section class="customer-view-section">
			<header class="customer-view-section__head">
				<span class="customer-view-section__icon" aria-hidden="true"><i class="fa fa-briefcase"></i></span>
				<h3 class="customer-view-section__title">{{ translate.instant('shared.addCustomerModal.sections.tax') }}</h3>
			</header>
			<div class="row g-3">
				<div class="col-12 col-md-6 col-xl-4" *ngIf="!isCompanyCustomer(customer)">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.idNumber') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.id_number))">{{ displayOptional(customer.id_number) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-4" *ngIf="isCompanyCustomer(customer)">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.vatNumber') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.id_number))">{{ displayOptional(customer.id_number) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-4">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.vatTaxNumber') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_vat_number))">{{ displayOptional(customer.customer_vat_number) }}</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-4">
					<div class="customer-view-field">
						<div class="customer-view-field__label">{{ translate.instant('shared.addCustomerModal.labels.companyIdNumber') }}</div>
						<div class="customer-view-field__value is-ltr" [class.is-empty]="isEmptyCellText(displayOptional(customer.customer_vat_tax))">{{ displayOptional(customer.customer_vat_tax) }}</div>
					</div>
				</div>
			</div>
		</section>
	</div>
	<div class="modal-footer customer-view__footer">
		<button type="button" class="customer-view__done" (click)="modal.close('Close click')">
			{{ translate.instant('customers.modal.viewClose') }}
		</button>
	</div>
	</div>
</ng-template>

<ng-template #dataDeleted let-modal>
	<div class="modal-header">
		<h4 class="modal-title"></h4>
		<button type="button" class="close btn-close"  style="color: grey;"  aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p class="text-center text-danger"> <i class="fa fa-trash text-danger"></i>
			{{curentLang === 'en' ? 'Are you sure you want to delete it?' : (curentLang === 'ar' ? '  هل تريد بالتأكيد حذفه؟ ' : ' אתב בטח שברוצנך למחוק?  ') }}
		</p>
	</div>
	<div class="modal-footer">
		<button type="button"
			class="btn btn-sm m-auto mt-2"
			style="background-color: #141414; color: #fff;"
			(click)="deleteCustomerById()">
			{{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
			<i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
		</button>
		<button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
			{{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
			<i class="fa fa-rotate-left mx-1"></i>
		</button>
	</div>
</ng-template>

<ng-container *ngIf="isInsideModal">
	<div class="container-fluid basic_table" >
		<div class="row">
			<div class="col-sm-12">
				<div class="card">
					<div class="card-header d-flex justify-content-between">
						<h5 style="color: grey;">
							{{ translate.instant('customers.title') }}
						</h5>
						<div>
							<button [hidden]="user_type == 200" class="btn m-1" style=" background-color: #141414; color: #fff;" (click)="openXl()">
								<i class="fa fa-plus-circle mx-1"></i>
								{{ translate.instant('customers.actions.addCustomer') }}
							</button>
							<button class="btn m-1 mx-1 btn-outline-warning"  (click)="getAllCustomersBasedOnMerchant()">
								<i class="fa fa-refresh mx-1"></i> {{ translate.instant('customers.actions.refresh') }}
							</button>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-5">
							<div class="form-group search m-3">
								<label for="seaarch" class="ml-2" style="color: grey;">{{ translate.instant('customers.search.label') }}</label>
								<input class="form-control  w-100" type="text" name="search"
									[ngModelOptions]="{standalone: true}" id="seaarch" [(ngModel)]="term" (input)="filterCustomers()" placeholder="{{ translate.instant('customers.search.placeholder') }}"/>
							</div>
						</div>
					</div>
					<div class="card-block row">
						<div class="col-sm-12 col-lg-12 col-xl-12">
							<div class="table-responsive">
								<table class="table table-light text-center table-hover  " >
									<thead>
										<tr>
											<th scope="col">{{ translate.instant('customers.table.headers.index') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerName') }}</th>
											<th scope="col">{{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerPhone') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerVatNumber') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerVatTax') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.idNumber') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.customerType') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.status') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.createdDate') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.view') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.update') }}</th>
											<th scope="col">{{ translate.instant('customers.table.headers.delete') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of customersData; let i = index">
											<td scope="row">{{ getCustomerRowNumber(i) }}</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(customerDisplayNameShort(item))">{{ customerDisplayNameShort(item) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(companyDisplayName(item))">{{ companyDisplayName(item) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.formattedPhone ?? item.customer_phone))">{{ displayOptional(item.formattedPhone ?? item.customer_phone) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.customer_vat_number))">{{ displayOptional(item.customer_vat_number) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.customer_vat_tax))">{{ displayOptional(item.customer_vat_tax) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isEmptyCellText(displayOptional(item.id_number))">{{ displayOptional(item.id_number) }}</span>
											</td>
											<td>
												<span [class.customers-table__empty-cell]="isUnknownCustomerType(item)">{{ customerTypeLabel(item) }}</span>
											</td>
											<td>
												<button  *ngIf="item.customer_status==1" class=" btn" style="border: none;" (click)="changeStatus(item?.customer_id, item.customer_status)">
													<i class="fa solid fa-solid fa-toggle-on " style=" color: #213FA6;" ></i>
												</button>
												<button  *ngIf="item.customer_status==59" class=" btn"  style="border: none;" (click)="changeStatus(item?.customer_id, item.customer_status)">
													<i class="fa solid fa-solid fa-toggle-off " style=" color: red;"></i>
												</button>
												<span *ngIf="item.customer_status != 1 && item.customer_status != 59" class="customers-table__empty-cell">{{ emptyCellDisplay }}</span>
											</td>
											<td>
												<span *ngIf="item.createdDate">{{ item.createdDate | date: 'dd/MM/yyyy'}}</span>
												<span *ngIf="!item.createdDate" class="customers-table__empty-cell">{{ emptyCellDisplay }}</span>
											</td>
											<td>
												<button class=" btn" style="border: none;" (click)="executeFunctionsView(  item?.customer_id,viewData ) ">
													<i class="fa fa-eye" style="color: grey;   cursor: pointer;"></i>
												</button>
											</td>
											<td >
												<button  class=" btn" style="border: none;"
													(click)="executeFunctions(  item?.customer_id, item ) ">
													<i class="fa fa-edit" style=" cursor: pointer; color: green;"></i>
												</button>
											</td>
											<td >
												<button
													[ngStyle]="{ 'pointer-events': item.customer_status == 1 ? 'none' : 'auto', 'color': item.customer_status == 1 ? 'gray' : 'red' }"
													class="btn"
													style="border: none;"
													(click)="getId(item?.customer_id);openVerticallyCentered(dataDeleted)">
													<i class="fa fa-trash-o" style=" cursor: pointer;"></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
								<div class="pagination-container">
									<span class="customers-page-report">{{ pageReport }}</span>
									<pagination-controls
										id="customers-modal"
										[previousLabel]="paginationPreviousLabel"
										[nextLabel]="paginationNextLabel"
										(pageChange)="onPageChange($event)">
									</pagination-controls>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
